export default "__VITE_ASSET__DI18Wq7k__"